import React from 'react';
import {ThemeProvider} from "@mui/material";
import {BrowserRouter as Router} from "react-router-dom"
import './App.css';
import theme from "./theme";
import {Main} from "./Main";

export interface BasicProps {
  mobile: boolean,
  vertical: boolean,
  setShowCover: React.Dispatch<React.SetStateAction<boolean>>
}



function App() {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <div style={{zoom: "100%", backgroundColor: "#fbfbfb", height: "100vh"}}>
                    <Main/>
                </div>
            </Router>
        </ThemeProvider>
    );
}

export default App;

